import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { EditSquare } from '../../../components/Icon';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { CompanyUsersSearchSelect } from '../../Vehicles/pages/create/CompanyUsersSearchSelect';
import { Input } from '../../../components/Input';
import { updateCompanyProperties } from '../actions';
import {
  COMPANY_DETAILS_COMPANY_DATA_CARD,
  COMPANY_VINDAT_RELATION_OPTIONS,
  COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  COMPANY_VINDAT_LEGAL_OPTIONS,
} from '../constants';
import { getPropByName } from '../../../utils/props';
import { COLOR_PRIMARY_1 } from '../../../vars';
import { selectConfig } from '../../Api/selectors';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './CardData.module.css';
import cn from 'classnames';
import { translateCountry } from '../translate-countries';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';

const Container = styled.div`
  font-size: 12px;

  .cardHeader {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
      margin-right: 5px;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .link-wrap {
    cursor: pointer;
    &:hover {
      color: ${COLOR_PRIMARY_1};
    }
  }
`;

const DROPDOWN_OPTIONS = {
  company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
  ORB_TDN_preference: ['ORB', 'TDN'],
  Vindat_Relation: COMPANY_VINDAT_RELATION_OPTIONS,
  Vindat_Franchisefomule: COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  vindat_legal_form: COMPANY_VINDAT_LEGAL_OPTIONS,
};

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyDataCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    COMPANY_DETAILS_COMPANY_DATA_CARD.map(property => {
      if (property === 'accountManagerId') {
        this.setState({ [property]: this.props.company?.accountManager?.id });
        return;
      }
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property] });
      }
    });
    if (this.props.company?.country_code) {
      this.setState({ country_code: this.props.company?.country_code });
    }
  }

  get homeAddress() {
    const address = this.props.company.addresses?.find(a => a.type?.name === 'home');

    return address;
  }

  get country() {
    return translateCountry(this.homeAddress?.country?.name, this.locale);
  }

  get locale() {
    return this.props.locale;
  }

  dropdown(type) {
    const vals = DROPDOWN_OPTIONS[type];

    const options = vals.map(val => ({
      label: this.lbl(`company.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state[type]);

    return (
      <div className={styles.container}>
        <Dropdown
          controlClassName={'dropdown-card'}
          options={options}
          value={value}
          onChange={pair => this.setState({ [type]: pair.value })}
          className={styles.dropdown}
        />
      </div>
    );
  }

  input(type) {
    return (
      <input
        className="form-control"
        value={this.state[type]}
        onChange={evt => this.setState({ [type]: evt.target.value })}
      />
    );
  }

  phoneNumber() {
    const fields = ['country_code', 'phone_number'];
    return (
      <HBox className="row-input" left>
        {fields.map((field, idx) => {
          return (
            <div key={field} className={`col-${idx + 1}`}>
              <input
                className="form-control"
                type="number"
                value={this.state[field] || ''}
                onChange={evt => this.setState({ [field]: evt.target.value })}
              />
            </div>
          );
        })}
      </HBox>
    );
  }

  checkbox(type, label) {
    return (
      <CheckboxComponent
        label={label}
        onChange={() => {
          if (!this.state.isEditCompany) return;
          const value = this.state[type] === '1' ? '0' : '1';

          this.setState({ [type]: value });
        }}
        checked={this.state[type] == '1'}
      />
    );
  }

  isShowPropertyCell(type) {
    if (this.state.isEditCompany) {
      return true;
    }
    if (this.props.company[type] && !this.state.isEditCompany) {
      return true;
    }
    return false;
  }

  windowOpen(url, name, specs) {
    if (!url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    return window.open(url);
  }

  edit(callback) {
    let prop = {
      properties: [],
      addresses: [],
      accountManagerId: this.state?.accountManagerId || null,
    };

    COMPANY_DETAILS_COMPANY_DATA_CARD.forEach(type => {
      if (type === 'accountManagerId') return;

      if (this.state[type] && type == 'phone_number') {
        prop.properties.push({
          name: type,
          value: this.state[type],
        });
        prop.properties.push({
          name: 'country_code',
          value: this.state?.country_code || '',
        });
      }
      if (this.state[type] && type != 'addresses') {
        prop.properties.push({
          name: type,
          value: this.state[type],
        });
      }
    });

    this.props.patch(prop.properties, this.props.company?.addresses, prop.accountManagerId, result => {
      this.reset();
    });
  }

  resetProps() {
    COMPANY_DETAILS_COMPANY_DATA_CARD.map(property => {
      if (this.props.company[property]) {
        this.setState({ [property]: this.props.company[property], isEditCompany: false });
      }
    });
    if (this.props.company?.country_code) {
      this.setState({ country_code: this.props.company?.country_code });
    }
  }

  rows(company) {
    return COMPANY_DETAILS_COMPANY_DATA_CARD;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const company = this.props.company;
    const address = this.homeAddress;
    const accountManager = company.accountManager;
    return (
      <Card className="company-info-card info-card data">
        <Container className="cardHeader">
          <HBox className="align-items-center">
            <h2 className="card-title m-0">{this.lbl('company.info.data.general_info')}</h2>

            <div
              className="icon-block"
              onClick={() => {
                this.setState(prevState => ({
                  isEditCompany: !prevState.isEditCompany,
                }));
              }}
            >
              {!this.props.noEdit && <EditSquare className={styles.iconEditSquare} />}
            </div>
          </HBox>

          <>
            {this.rows().map(property => {
              if (property == 'name') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        {this.state.isEditCompany ? (
                          <>
                            <label className={cn('form-label', styles.label)}>
                              {this.lbl(`company.property.${property}`)}
                            </label>
                            {this.input(property)}
                          </>
                        ) : (
                          <div className={styles.formField}>
                            <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                            <div className={styles.labelTable}>
                              {company['company_type'] == 'company'
                                ? `${company['name'] || ''}`
                                : `${company[property] || ''} ${company['surname'] ? company['surname'] : ''}`}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )
                );
              }

              if (property == 'headquarters') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    {this.checkbox(property, this.lbl(`company.property.${property}`))}
                  </div>
                );
              }

              if (property == 'company_from_eu') {
                return (
                  this.isShowPropertyCell && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {this.lbl(`company.property.${property}.${company.company_from_eu || 'OUTSIDE_EU'}`)}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'address') {
                return (
                  address && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          <div className={styles.labelTable}>
                            <strong className={styles.label}>
                              {!address
                                ? ''
                                : address.addressLine1 + ' ' + address.postcode + ' ' + address.city + ' ' + this.country}
                            </strong>
                          </div>
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {!address
                              ? ''
                              : address.addressLine1 + ' ' + address.postcode + ' ' + address.city + ' ' + this.country}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'phone_number') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        // this.input(property)
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.phoneNumber()}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {`${company['country_code'] ? `+${company['country_code']}` : ''} ${company[property] ||
                              company['telephonenr']}`}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'email') {
                return (
                  company['company_type'] !== 'company' &&
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }
              if (property == 'company_email') {
                return (
                  company['company_type'] == 'company' &&
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'website') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.input(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            <div className="link-wrap" onClick={() => this.windowOpen(company[property])}>
                              {company[property]}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'accountManagerId') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>

                        <CompanyUsersSearchSelect
                          key={`${property}`}
                          userValue={this.state[property]}
                          selectedCreditorId={this.state[property]}
                          onChange={value => this.setState({ [property]: value })}
                          companyDetails
                        />
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{`${getPropByName(accountManager, 'name') || ''} ${getPropByName(
                          accountManager,
                          'surname',
                        ) || ''}`}</div>
                      </div>
                    )}
                  </div>
                );
              }

              if (property == 'ORB_TDN_preference') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>{' '}
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              // if (property == 'vindat_auction') {
              //   return (
              //     <Row key={property}>
              //       <Cell>{this.lbl(`company.property.${property}`)}</Cell>
              //       {this.state.isEditCompany ? (
              //         this.checkbox(property)
              //       ) : (
              //         <Cell>
              //           <Checkbox checked={company[property]}></Checkbox>
              //         </Cell>
              //       )}
              //     </Row>
              //   );
              // }
              // if (property == 'vindat_valuation_center') {
              //   return (
              //     <Row key={property}>
              //       <Cell>{this.lbl(`company.property.${property}`)}</Cell>

              //       {this.state.isEditCompany ? (
              //         this.checkbox(property)
              //       ) : (
              //         <Cell>
              //           <Checkbox checked={company[property]}></Checkbox>
              //         </Cell>
              //       )}
              //     </Row>
              //   );
              // }
              // if (property == 'in_the_wallet') {
              //   return (
              //     <Row key={property}>
              //       <Cell>{this.lbl(`company.property.${property}`)}</Cell>

              //       {this.state.isEditCompany ? (
              //         this.checkbox(property)
              //       ) : (
              //         <Cell>
              //           <Checkbox checked={company[property]}></Checkbox>
              //         </Cell>
              //       )}
              //     </Row>
              //   );
              // }

              if (property == 'RDW_number') {
                return this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' &&
                  company['company_from_eu'] == 'NL' ? (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
                        {this.input(property)}
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                );
              }
              //
              if (property == 'Vindat_Relation') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'Vindat_Franchisefomule') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'vindat_legal_form') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'Vindat_Relation') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'vindat_valuation_center') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'in_the_wallet') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }
              if (property == 'ORB_TDN_preference') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      {this.state.isEditCompany ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`company.property.${property}`)}
                          </label>
                          {this.dropdown(property)}
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>{company[property]}</div>
                        </div>
                      )}
                    </div>
                  )
                );
              }

              if (property == 'createdAt') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
                        <div className={styles.labelTable}>
                          <strong className={styles.label}>{dayjs(company[property]).format('DD-MM-YYYY')}</strong>
                        </div>
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{dayjs(company[property]).format('DD-MM-YYYY')}</div>
                      </div>
                    )}
                  </div>
                );
              }
              return (
                this.isShowPropertyCell(property) && (
                  <div className={styles.containerLabel} key={property}>
                    {this.state.isEditCompany ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`company.property.${property}`)}</label>
                        {this.input(property)}
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {this.lbl(`company.property.${property}.${company[property]}`)}
                        </div>
                      </div>
                    )}
                  </div>
                )
              );
            })}
          </>

          {this.state.isEditCompany && (
            <div className="d-flex gap-2 mt-2">
              <ButtonComponent style={'ButtonSoftDelete'} onClick={this.resetProps.bind(this)}>
                {this.lbl('cancel')}
              </ButtonComponent>
              &nbsp; &nbsp;
              <ButtonComponent style={'ButtonSoftEdit'} onClick={this.edit.bind(this)}>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          )}
        </Container>
      </Card>
    );
  }
}

CompanyDataCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, addresses, accountManagerId, callback) {
      dispatch(updateCompanyProperties(ownProps.company?.id, props, addresses, accountManagerId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyDataCard = compose(withConnect, withRouter)(CompanyDataCardComp);
